import { useEffect, useState } from "react";
import { useApiCall } from "./useApiCall";
import { useAuth } from "./useAuth";
import { useQuiz } from "./useQuiz";

export const useSaveQuiz = () => {
  const { user } = useAuth();
  const { quizResponses } = useQuiz();
  const { executeApiCall, apiCallResponse, apiCallStatus } = useApiCall();
  const [isSavingQuiz, setIsSavingQuiz] = useState(false);
  const [savedQuiz, setSavedQuiz] = useState();
  const [saveQuizError, setSaveQuizError] = useState();

  const saveQuiz = () => {
    setSaveQuizError();
    setSavedQuiz();

    if (user) {
      const requestOptions = {
        url: `/users/${user.id}/preferences`,
        method: "PUT",
        data: quizResponses,
      };

      setIsSavingQuiz(true);
      executeApiCall(requestOptions);
    }
  };

  useEffect(() => {
    switch (apiCallStatus) {
      case "success":
        if (apiCallResponse.data.error) {
          setSaveQuizError(apiCallResponse.data.error.userMessage);
          setIsSavingQuiz(false);
        } else {
          setSaveQuizError();

          if (apiCallResponse.data.data) {
            const { preference } = apiCallResponse.data.data;

            setIsSavingQuiz(false);
            setSavedQuiz(preference);
          }
        }
        break;
      case "error":
        setIsSavingQuiz(false);
    }
  }, [apiCallStatus, apiCallResponse]);

  return {
    isSavingQuiz,
    saveQuiz,
    savedQuiz,
    saveQuizError,
  };
};
